export default __webpack_public_path__ + "static/media/CIA-Fidelity-Computer-Crime-Declaration-ManagingAgent.308be4db.pdf";